import { Role } from 'src/app/models/role.model';
import { List } from 'src/app/models/list.model';

export class LoadRoles {
  static readonly type = '[Roles List] Load Roles';
}

export class LoadRolesSuccess {
  static readonly type = '[Roles Effect] Load Roles Success';
  constructor(public list: Role[]) {}
}

export class UpdateRole {
  static readonly type = '[Roles List Operations] Update Role';
  constructor(public role: Role) {}
}

export class UpdateRoleSuccess {
  static readonly type = '[Roles List Operations] Update Role Success';
  constructor(public role: Role) {}
}

export class CreateRole {
  static readonly type = '[Create Role Component] Create Role';
  constructor(public role: Role) {}
}

export class CreateRoleSuccess {
  static readonly type = '[Roles List Operations] Create Role Success';
  constructor(public role: Role) {}
}

export class RemoveRole {
  static readonly type = '[Roles List Operations] Delete Role';
  constructor(public role: Role) {}
}
